import { render, staticRenderFns } from "./EditContract.vue?vue&type=template&id=3c19c210"
import script from "./EditContract.vue?vue&type=script&lang=ts"
export * from "./EditContract.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports